import { inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { RestApiV2Service } from '../http/rest-api-v2.service';
import { UserService } from '../user-management/user.service';
import { take } from 'rxjs';
import { WalletOverview, PointsHistoryItem, PointsProfile, PointsWallet } from '../../../shared/models/points/points.model';
import { isPlatformBrowser } from '@angular/common';


export enum SourceType {
  TREATMENT = "TREATMENT",
  PRESCRIPTION = "PRESCRIPTION",
  FOLLOWUP = "FOLLOWUP",
  SCREENING = "SCREENING",
  EFFECTS = "EFFECTS"
}

@Injectable({
  providedIn: 'root',
})
export class PointsService {
  private readonly restApi = inject(RestApiV2Service);
  private readonly userService = inject(UserService);
  private readonly platformId = inject(PLATFORM_ID);

  readonly pointsOverview = signal<WalletOverview>({ history: [], profile: { level: '', next_level: '', points_to_next_level: 0, progress_percent: 0 }, wallet: { total_points: 0 } });
  
  getMyPointsOverview() {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const response = this.restApi.get<{data: WalletOverview}>(`points/overview/${this.userService.userData()?.id}`);

    response.request$
    .pipe(take(1))
    .subscribe(response => {
      this.pointsOverview.set(response.data);
      console.log(this.pointsOverview());
    });

    response.error$
    .subscribe(error => {
      console.log(error);
    });
  }

  updatePointsAwarded(data: {
    wallet: PointsWallet;
    profile: PointsProfile;
    history: Partial<PointsHistoryItem>;
  }) {
    this.pointsOverview.update((current) => {
      // Agregar el nuevo history al inicio del array (más reciente primero)
      // Hacer cast al tipo esperado ya que la estructura base es compatible
      const newHistoryItem = data.history as PointsHistoryItem;
      
      const updatedHistory = [newHistoryItem, ...current.history];
      
      return {
        ...current,
        wallet: data.wallet,
        profile: data.profile,
        history: updatedHistory
      };
    });
  }
}
